import React, { useState, useEffect, useRef } from "react";
import {
  Divider,
  Grid,
  Typography,
  makeStyles,
  Box,
  CircularProgress,
} from "@material-ui/core";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import { Card, CardContent, CardActions } from "../../components/Card";
import Text from "../../components/Text";
import Button from "../../components/Button";
import Table from "../../components/Table";
import { useAlert } from "../../components/Alert";
import divisions from "../../divisions.json";
import { TextInput, DateInput, Select } from "../../components/Form";
import LoadingModal from "../../components/LoadingModal";
import TrackRecordTable from "./TrackRecordTable";

const GET_USER = gql`
  query user($id: Int) {
    user(id: $id) {
      id
      username
      fullName
      gender
      mobile
      phone
      fax
      email
      address {
        division
        subdivision
        address
      }
      status
      activatedAt
      expiredAt
      note
      identity
      createdAt
    }
  }
`;
const UPDATE_USER = gql`
  mutation updateUser($userInput: UserInput!, $console: Boolean) {
    updateUser(userInput: $userInput, console: $console)
  }
`;
export default function PersonalTrackingRecord({ id }) {
  const data = [];
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    username: "",
    fullName: "",
    genderArray: [
      { label: "男", value: "MALE" },
      { label: "女", value: "FEMALE" },
    ],
    genderObject: {},
    mobile: "",
    phone: "",
    email: "",
    line: "",
    divisionArray: [],
    division: "null",
    divisionObject: {},
    subdivisionsArray: [],
    subdivisions: "",
    subdivisionsObject: {},
    address: "",
    userStatusArray: [
      { label: "有付費", value: "有付費" },
      { label: "未付費", value: "未付費" },
      { label: "已到期", value: "已到期" },
    ],
    userStatusObject: {},
    paymentTypeArray: [
      { label: "轉帳匯款", value: "轉帳匯款" },
      { label: "信用卡付款", value: "信用卡付款" },
    ],
    paymentTypeObject: {},
    subscriptionTypeArray: [],
    subscriptionTypeObject: {},
    theCourtArray: [
      {
        label: "臺灣台北地方法院",
        value: "臺灣台北地方法院",
      },
      {
        label: "臺灣新北地方法院",
        value: "臺灣新北地方法院",
      },
      {
        label: "臺灣士林地方法院",
        value: "臺灣士林地方法院",
      },
      {
        label: "臺灣桃園地方法院",
        value: "臺灣桃園地方法院",
      },
      {
        label: "臺灣新竹地方法院",
        value: "臺灣新竹地方法院",
      },
      {
        label: "臺灣苗栗地方法院",
        value: "臺灣苗栗地方法院",
      },
      {
        label: "臺灣臺中地方法院",
        value: "臺灣臺中地方法院",
      },
      {
        label: "臺灣南投地方法院",
        value: "臺灣南投地方法院",
      },
      {
        label: "臺灣彰化地方法院",
        value: "臺灣彰化地方法院",
      },
      {
        label: "臺灣雲林地方法院",
        value: "臺灣雲林地方法院",
      },
      {
        label: "臺灣嘉義地方法院",
        value: "臺灣嘉義地方法院",
      },
      {
        label: "臺灣臺南地方法院",
        value: "臺灣臺南地方法院",
      },
      {
        label: "臺灣橋頭地方法院",
        value: "臺灣橋頭地方法院",
      },
      {
        label: "臺灣高雄地方法院",
        value: "臺灣高雄地方法院",
      },
      {
        label: "臺灣屏東地方法院",
        value: "臺灣屏東地方法院",
      },
      {
        label: "臺灣臺東地方法院",
        value: "臺灣臺東地方法院",
      },
      {
        label: "臺灣花蓮地方法院",
        value: "臺灣花蓮地方法院",
      },
      {
        label: "臺灣宜蘭地方法院",
        value: "臺灣宜蘭地方法院",
      },
      {
        label: "臺灣基隆地方法院",
        value: "臺灣基隆地方法院",
      },
      {
        label: "臺灣澎湖地方法院",
        value: "臺灣澎湖地方法院",
      },
      {
        label: "福建金門地方法院",
        value: "福建金門地方法院",
      },
      {
        label: "福建連江地方法院",
        value: "福建連江地方法院",
      },
    ],
    theCourtObject: {},
    note: "",
    activatedAt: null,
    expiredAt: null,
    createdAt: null,
  });
  const subdivisionsRef = useRef("");
  function changeDataListener(key, v) {
    if (key === "division") {
      if (Boolean(v) && v !== "null") {
        const subdivisionsKey = v && Object.keys(divisions[v].subdivisions);
        const newSubdivisionsArray = [];
        subdivisionsKey.map((item) => {
          newSubdivisionsArray.push({
            value: item,
            label: divisions[v].subdivisions[item].zhTW,
          });
        });
        if (Boolean(subdivisionsRef.current)) {
          const hasSubdivisions = newSubdivisionsArray.find(
            (item) => item.value == subdivisionsRef.current
          );
          if (hasSubdivisions) {
            changeData("subdivisions", hasSubdivisions.value);
            changeData("subdivisionsObject", hasSubdivisions, true);
          }
        }
        changeData("subdivisionsArray", newSubdivisionsArray, true);
      } else {
        subdivisionsRef.current = "";
        changeData("subdivisionsArray", []);
        changeData("subdivisions", "");
        changeData("subdivisionsObject", {}, true);
      }
    }
  }
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    DocumentContainerButtonEnd: {
      display: "flex",
      justifyContent: "flex-end",
    },
    DocumentContainerBetween: {
      alignItems: "center",
      //flexDirection: "row",
      justifyContent: "space-between",
    },
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
  });
  const classes = useStyles();
  const [getUser, { data: userData, loading }] = useLazyQuery(GET_USER, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ user }) {
      if (user) {
        changeData("username", user.username);
        changeData("fullName", user.fullName);
        changeData("genderObject", {
          label: getGender(user.gender),
          value: user.gender,
        });
        changeData("mobile", user.mobile);
        changeData("line", user.line);
        changeData("email", user.email);
        changeData(
          "userStatusObject",
          newData.userStatusArray.find((item) => item.value === user.status)
        );
        if (Boolean(user.address)) {
          changeData("divisionObject", {
            label: divisions[user.address.division]["zhTW"],
            value: user.address.division,
          });
          changeData("division", user.address.division);

          changeData("subdivisionsObject", {
            label:
              divisions[user.address.division]["subdivisions"][
                user.address.subdivision
              ]["zhTW"],
            value: user.address.subdivision,
          });
          changeData("subdivisions", user.address.subdivision);
          changeData("address", user.address.address);
        }
        if (Boolean(user.activatedAt)) {
          changeData(
            "activatedAt",
            moment(user.activatedAt).format("yyyy/MM/dd")
          );
          changeData("expiredAt", moment(user.expiredAt).format("yyyy/MM/dd"));
        }
        changeData("createdAt", user.createdAt);
        changeData("note", user.note, true);
      }
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });
  const [updateUser, { loading: updateUserLoading }] = useMutation(
    UPDATE_USER,
    {
      onCompleted({ updateUser }) {
        if (updateUser) {
          getUser({ variables: { id } });
          return Alert.notice("儲存成功！");
        } else {
          return Alert.notice("儲存失敗，請重新嘗試！");
        }
      },
      onError(error) {
        return Alert.notice(error.message.replace("GraphQL error: ", ""));
      },
    }
  );
  useEffect(() => {
    if (Boolean(id)) {
      getUser({ variables: { id: Number(id) } });
    }
  }, [id]);
  useEffect(() => {
    const divisionKey = Object.keys(divisions);
    const newDivisionArray = [];
    divisionKey.map((item) => {
      newDivisionArray.push({
        value: item,
        label: divisions[item].zhTW,
      });
    });
    changeData("divisionArray", newDivisionArray, true);
  }, []);

  function _updateUser() {
    const userInput = {
      id,
      fullName: newData.fullName,
      gender: newData.genderObject.value,
      mobile: newData.mobile,
      line: newData.line,
      email: newData.email,
      address: {
        division: newData.division,
        subdivision: newData.subdivisions,
        address: newData.address,
      },
      status: newData.userStatusObject.value,
      activatedAt: newData.activatedAt,
      expiredAt: newData.expiredAt,
      note: newData.note,
      identity: userData?.user.identity,
    };

    updateUser({ variables: { userInput, console: true } });
  }
  function getGender(value) {
    switch (value) {
      case "MALE":
        return "男";
      case "FEMALE":
        return "女";
      default:
        return null;
    }
  }

  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  }
  return (
    <Card>
      <LoadingModal loading={updateUserLoading} />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item sm={2}>
            <Typography color="primary">帳號</Typography>
            <Typography>{newData.username}</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">姓名</Typography>
            <TextInput
              value={newData.fullName ? newData.fullName : ""}
              onChange={(v) => {
                changeData("fullName", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">性別</Typography>
            <Select
              items={newData.genderArray}
              value={newData.genderObject}
              onChange={(e, v) => {
                if (v) {
                  changeData("genderObject", v, true);
                } else {
                  changeData(
                    "genderObject",
                    { label: "男", value: "MALE" },
                    true
                  );
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">電話</Typography>
            <TextInput
              value={newData.mobile ? newData.mobile : ""}
              onChange={(v) => {
                changeData("mobile", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">信箱</Typography>
            <TextInput
              value={newData.email ? newData.email : ""}
              onChange={(v) => {
                changeData("email", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">Line</Typography>
            <TextInput
              value={newData.line ? newData.line : ""}
              onChange={(v) => {
                changeData("line", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              縣市
            </Typography>
            <Select
              placeholder={"請選擇縣市"}
              items={newData.divisionArray}
              value={
                newData.divisionObject.value ? newData.divisionObject : null
              }
              onChange={(e, value) => {
                if (value) {
                  changeData("division", value.value);
                  changeData("divisionObject", value, true);
                } else {
                  changeData("division", "null");
                  changeData("divisionObject", {}, true);
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography color="primary" style={{ fontSize: 15 }}>
              區域
            </Typography>
            <Select
              placeholder={"請選擇地區"}
              items={newData.subdivisionsArray}
              value={
                newData.subdivisionsObject.value
                  ? newData.subdivisionsObject
                  : null
              }
              onChange={(e, value) => {
                if (value) {
                  changeData("subdivisions", value.value);
                  changeData("subdivisionsObject", value, true);
                } else {
                  changeData("subdivisions", null);
                  changeData("subdivisionsObject", {}, true);
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={3}>
            <Typography color="primary">地址</Typography>
            <TextInput
              value={newData.address ? newData.address : ""}
              onChange={(v) => {
                changeData("address", v, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item sm={3}>
            <Typography color="primary">訂閱法院</Typography>
            <Select
              items={newData.theCourtArray}
              value={newData.theCourtObject}
              onChange={(e, v) => {
                if (v) {
                  changeData("theCourtObject", v, true);
                } else {
                  changeData("theCourtObject", {}, true);
                }
              }}
              disabled
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">註冊時間</Typography>
            <Typography>
              {moment(new Date(newData.createdAt)).format("yyyy-MM-DD  HH:mm")}
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">訂閱方案</Typography>
            <Select
              items={newData.subscriptionTypeArray}
              value={newData.subscriptionTypeObject}
              onChange={(e, v) => {
                if (v) {
                  changeData("subscriptionTypeObject", v, true);
                } else {
                  changeData("subscriptionTypeObject", {}, true);
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">付款方式</Typography>
            <Select
              items={newData.paymentTypeArray}
              value={newData.paymentTypeObject}
              onChange={(e, v) => {
                if (v) {
                  changeData("paymentTypeObject", v, true);
                } else {
                  changeData("paymentTypeObject", {}, true);
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">狀態</Typography>
            <Select
              items={newData.userStatusArray}
              value={newData.userStatusObject}
              onChange={(e, v) => {
                if (v) {
                  changeData("userStatusObject", v, true);
                } else {
                  changeData("userStatusObject", {}, true);
                }
              }}
            />
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">應付金額</Typography>
            <Typography>{"0"}</Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography color="primary">實付金額</Typography>
            <Typography>{"0"}</Typography>
          </Grid>
          <Grid item container sm={12}>
            <Grid item>
              <Typography color="primary">開通</Typography>
            </Grid>
            <Grid item container spacing={1} alignItems="flex-end" sm={12}>
              <Grid item>
                <DateInput
                  value={newData.activatedAt}
                  format="yyyy/MM/dd"
                  onChange={(v) => {
                    changeData("activatedAt", v, true);
                  }}
                />
              </Grid>
              <Grid item>
                <Typography>至</Typography>
              </Grid>
              <Grid item>
                <DateInput
                  value={newData.expiredAt}
                  format="yyyy/MM/dd"
                  minDate={newData.activatedAt}
                  onChange={(v) => {
                    changeData("expiredAt", v, true);
                  }}
                />
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={
                    newData.activatedAt === null || newData.expiredAt === null
                  }
                >
                  開通帳號
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12}>
            <Typography color="primary">備註事項</Typography>
            <TextInput
              value={newData.note ? newData.note : ""}
              multiline
              rows={3}
              fullWidth
              onChange={(v) => {
                changeData("note", v, true);
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={1} justify="center">
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onPress={() => {
                _updateUser();
              }}
            >
              儲存
            </Button>
          </Grid>
        </Grid>
      </CardActions>
      <Divider />
      <TrackRecordTable id={id} name={newData.fullName} />
    </Card>
  );
}
